import { LitElement, html } from 'lit-element';
import { theme } from '../theme';
import { library, dom, config as fontAwesomeConfig } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { StateMixin } from '../StateMixin';

// Make sure this is before any other `fontawesome` API calls. Without it,
// fontAwesome will attempt to add an inline style tag which can trigger
// content security policy.
fontAwesomeConfig.autoAddCss = false;

const _library = Symbol();
const _hasUpdated = Symbol();
const _document = Symbol();
const _window = Symbol();

export class BaseElement extends StateMixin(LitElement) {
	constructor() {
		super();

		this[_library] = library;
		this[_hasUpdated] = false;
		this[_document] = null;

		this.library.add(faInfoCircle);
		

		dom.watch({
			autoReplaceSvgRoot: this.shadowRoot,
			observeMutationsRoot: this.shadowRoot
		});
	}
	static get styles() {
		return [theme];
	}
	get library() {
		return this[_library];
	}
	get hasUpdated() {
		return this[_hasUpdated];
	}
	get document() {
		return this[_document];
	}
	set document(v) {
		if(v !== null && !(v instanceof HTMLDocument))
			throw new TypeError('document must be an instance of HTMLDocument.');
		this[_document] = v;
	}
	get window() {
		return this[_window];
	}
	set window(v) {
		if(v !== null && !(v instanceof Window))
			throw new TypeError('window must be an instance of Window.');
		this[_window] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-document', { callback: document => this.document = document });
		this.emit('get-window', { callback: window => this.window = window });
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.document = null;
		this.window = null;
	}
	// async extractDOM() {
	// 	const container = this.document.createElement('div');
	// 	container.style.position = 'absolute';
	// 	container.style.top = '0';
	// 	container.style.left = '0';
	// 	container.style.backgroundColor = 'green';

	// 	const hostWidth = this.shadowRoot.host.style.width;
	// 	this.shadowRoot.host.style.width = '8.5in';

	// 	const _extractDOM = (node) => {
	// 		const clone = (node.shadowRoot) ?
	// 			this.document.createElement('div') :
	// 			node.cloneNode();
			
	// 		if(node instanceof HTMLElement) {
	// 			const style = this.window.getComputedStyle(node);
	// 			[...style].forEach(key => clone.style.setProperty(key, style.getPropertyValue(key), 'important'));
	// 		}
	// 		[...(node.shadowRoot ? node.shadowRoot.childNodes : node.childNodes)].map(child => clone.appendChild(_extractDOM(child)));
	// 		return clone;
	// 	};
		
	// 	[...this.shadowRoot.children].map(child => {
	// 		container.appendChild(_extractDOM(child));
	// 	});

	// 	this.document.body.appendChild(container);
		
	// 	const dataUrl = await domtoimage.toPng(container);
	// 	// const img = new Image();
	// 	// img.src = dataUrl;
	// 	// document.body.appendChild(img);

	// 	this.shadowRoot.host.style.width = hostWidth;
		
	// 	return container;
	// }
	firstUpdated(changedProperties) {
		super.firstUpdated(changedProperties);
		this[_hasUpdated] = true;
	}
	emit(eventName, detail) {
		this.dispatchEvent(
			new CustomEvent(eventName, {
				detail,
				bubbles: true,
				composed: true
			})
		);
	}
}